import React, { Component } from 'react'
import NoteForm from './NoteForm'
import { Link, withRouter } from 'react-router-dom'
import Toolbar, { ToolbarButton } from './Toolbar'
import Card, { CardContent } from 'material-ui/Card'
import { withStyles } from 'material-ui/styles'
import { EditorState } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import BackIcon from 'material-ui-icons/KeyboardArrowLeft'

const styles = theme => ({
  noteCard: {
    marginLeft: 2 * theme.spacing.unit,
    marginRight: 2 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  }
})

class NoteCreationPage extends Component {
  constructor(props) {
    super(props)
    this.state = { editorState: EditorState.createEmpty(), toolbar: null }
    this.handleNewProps(this.props)
  }
  componentWillUpdate(newProps) {
    this.handleNewProps(newProps)
  }
  handleNewProps(props) {
    if (props.createdNoteId) {
      props.history.push(`/notes/${props.createdNoteId}`)
      props.resetCreatedNoteId()
    }
  }
  handleSubmit({ title }) {
    const editorState = this.state.editorState
    const contentState = editorState.getCurrentContent()
    const content = stateToHTML(contentState)
    this.props.createNote({ title, content, userId: this.props.user.uid })
  }
  handleEditorChange(editorState) {
    this.setState({ editorState })
  }
  setRef = element => {
    this.setState({ toolbar: element })
  }
  render() {
    const { classes } = this.props
    return (
      <div>
        <Toolbar ref={this.setRef}>
          <ToolbarButton icon color="primary" component={Link} to="/notes">
            <BackIcon />
          </ToolbarButton>
        </Toolbar>
        <Card className={classes.noteCard}>
          <CardContent>
            {this.state.toolbar && (
              <NoteForm
                onSubmit={values => this.handleSubmit(values)}
                editorState={this.state.editorState}
                onEditorChange={editorState =>
                  this.handleEditorChange(editorState)}
                toolbar={this.state.toolbar}
              />
            )}
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default withStyles(styles)(withRouter(NoteCreationPage))



// WEBPACK FOOTER //
// ./src/components/NoteCreationPage.js